import axios from 'axios';
import {
    FETCH_POST_SUCCESS,
    FETCH_POST_MORE_SUCCESS
} from '../constants/ActionTypes';

export const fetchPostSuccess = data => {
    return {
        type: FETCH_POST_SUCCESS,
        payload: data
    }
}

export const fetchPostMoreSuccess = data => {
    return {
        type: FETCH_POST_MORE_SUCCESS,
        payload: data
    }
}

const buildPostUrl = (payload) => {
    const { company, salesmanCode, language, username, page, perPage } = payload;
    return `${process.env.REACT_APP_API_URL}post?company=${company}&salesmanCode=${salesmanCode}&language=${language}&username=${username}&page=${page}&perPage=${perPage}`;
}

export const fetchPost = (payload) => {
    return dispatch => {
        return axios.get(buildPostUrl(payload), {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            dispatch(fetchPostSuccess(response.data));
        })
        .catch(error => {
            //
        })
    }
}

export const fetchPostMore = (payload) => {
    return dispatch => {
        return axios.get(buildPostUrl(payload), {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            dispatch(fetchPostMoreSuccess(response.data));
        })
        .catch(error => {
            //
        })
    }
}
